import { NgIf } from "@angular/common";
import { ChangeDetectionStrategy, Component, HostBinding, Signal } from "@angular/core";
import { AuthPromptComponent, AuthStore } from "app/auth";
import {
  ChatBoxContentId,
  ChatBoxContentSwitcher,
} from "app/chat/common/chat-box-content.switcher";
import { ScoreFormComponent } from "app/chat/score-form";
import { PersonalInfoComponent } from "../../switch/personal-info";
import { MessagesBoxComponent } from "../messages-box-component";

/** A component displaying the messages available in the lastly received conversation block. */
@Component({
  selector: "[chatBox]",
  templateUrl: "./template.html",
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgIf,
    MessagesBoxComponent,
    PersonalInfoComponent,
    ScoreFormComponent,
    AuthPromptComponent,
  ],
})
export class ChatBoxComponent {
  @HostBinding("class") hostClasses = "rounded-bottom-5";
  @HostBinding("style") styleClasses =
    "border-width: 0 var(--fof-main-border-width) var(--fof-main-border-width) var(--fof-main-border-width); border-style: solid; border-color: var(--fof-border-color);";

  protected readonly contentId: Signal<ChatBoxContentId>;
  protected readonly shouldPrompt: Signal<boolean>;
  protected readonly isAuthPending: Signal<boolean>;

  constructor(contentSwitcher: ChatBoxContentSwitcher, authStore: AuthStore) {
    this.contentId = contentSwitcher.id;
    this.shouldPrompt = authStore.shouldPrompt;
    this.isAuthPending = authStore.isPending;
  }
}
